import React, { useEffect, useRef, useState } from "react";
import "./css/country-select.css";

const CountrySelect = ({
  label,
  options,
  name,
  required,
  selectedOptions,
  setSelectedOptions,
  handleSelect,
  isError,
  errorMessage,
}) => {
  const [isOpen, setIsOpen] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [isActive, setIsActive] = useState(false);

  const dropdownRef = useRef(null);

  const filteredOptions = options?.filter((country) =>
    country.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const handleClearAll = (e) => {
    e.stopPropagation();
    setSelectedOptions([]);
    if (handleSelect) {
      handleSelect([]);
    }
  };

  const handleRemove = (option) => {
    const newSelectedOptions = selectedOptions.filter(
      (item) => item !== option
    );
    setSelectedOptions(newSelectedOptions);
    if (handleSelect) {
      handleSelect(newSelectedOptions);
    }
  };

  useEffect(() => {
    if (selectedOptions.length === 0) {
      setIsActive(false);
    }
  }, [selectedOptions]);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
        if (selectedOptions.length === 0) setIsActive(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [selectedOptions]);

  const toggleDropdown = () => {
    setIsOpen((prev) => !prev);
    setIsActive(true);
  };

  return (
    <div ref={dropdownRef} className={`pre-booking-multi-select-wrapper `}>
      <div
        onClick={toggleDropdown}
        className={`multi-select-dropdown ${
          isOpen ? "active change-border-color-select" : ""
        }`}
      >
        <div className="pre-booking-multi-select-input">
          {label && (
            <label
              className={`pre-booking-multi-select-label ${
                isOpen ? "change-label-color" : ""
              } ${isError ? "error-label" : ""}`}
            >
              {label} {required && <span className="required">*</span>}
            </label>
          )}

          <div
            className={`pre-booking-selected-container ${
              isActive ? "dropdown-active" : ""
            }`}
          >
            {Array.isArray(selectedOptions) && selectedOptions.length > 0 && (
              <div className="">
                {selectedOptions.map((option, index) => (
                  <span key={index} className="pre-booking-selected-item">
                    {option}
                    <button
                      className="pre-booking-remove-btn"
                      onClick={(e) => {
                        e.stopPropagation();
                        handleRemove(option);
                      }}
                    >
                      ✕
                    </button>
                  </span>
                ))}
              </div>
            )}
          </div>

          {Array.isArray(selectedOptions) && selectedOptions.length > 0 && (
            <button
              className={`pre-booking-clear-btn ${
                isActive ? "dropdown-cancel-active" : ""
              }`}
              onClick={handleClearAll}
            >
              Clear All
            </button>
          )}

          <button className="pre-booking-toggle-btn">
            {isOpen ? "▲" : "▼"}
          </button>
        </div>
        {isError && <p className="pre-booking-error-message">{errorMessage}</p>}
        {isOpen && (
          <div
            className={`pre-booking-dropdown-list ${
              isActive ? "dropdown-active" : ""
            }`}
          >
            <div 
            className="multi-select-search"
            onClick={(e) => e.stopPropagation()}
            >
              <input
                type="text"
                placeholder="Search a country..."
                value={searchTerm}
                onChange={(e) => setSearchTerm(e.target.value)}
              />
            </div>
            {filteredOptions?.map((country, idx) => (
              <div
                key={idx}
                className="pre-booking-dropdown-item"
                onClick={() => {
                  const newSelectedOptions = selectedOptions.includes(country)
                    ? selectedOptions.filter((item) => item !== country)
                    : [...selectedOptions, country];
                  setSelectedOptions(newSelectedOptions);
                  if (handleSelect) {
                    handleSelect(newSelectedOptions);
                  }
                }}
              >
                <input
                  type="checkbox"
                  checked={selectedOptions.includes(country)}
                  readOnly
                />
                {country}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default CountrySelect;
